<template>
  <d2-container>
      <el-form inline>
          <el-form-item>
              <el-input
                      clearable
                      @keyup.enter.native="getSearch()"
                      style="width: 200px;margin-right: 20px;"
                      class="filter-item"
                      placeholder="搜索"
                      size="small"
                      v-model="listQuery.keyword"
              ></el-input>
          </el-form-item>
          <el-form-item>
              <el-select
                      class="filter-item"
                      v-model="listQuery.status"
                      placeholder="请选择状态"
                      size="small"
                      style="margin-right: 20px"
                      clearable
              >
                  <el-option
                          :key="1"
                          label="开启"
                          :value="1"
                  ></el-option>
                  <el-option
                          :key="0"
                          label="关闭"
                          :value="0"
                  ></el-option>
              </el-select>
          </el-form-item>
          <el-form-item>
              <el-button @click="getSearch()"  class="filter-item" type="primary" icon="search" size="small">搜索</el-button>
          </el-form-item>
      </el-form>

    <el-button
      class="filter-item"
      type="primary"
      size="small"
      icon="el-icon-circle-plus"
      @click="add"
    >添加</el-button>
    <el-table
      size="small"
      :key="tableKey"
      stripe
      border
      highlight-current-row
      style="margin-top: 20px"
      :data="list"
    >
      <el-table-column align="center" label="id">
        <template slot-scope="scope">
          <span>{{ scope.row.id }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="名称">
        <template slot-scope="scope">
          <span>{{ scope.row.name }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="状态">
        <template slot-scope="scope">
            <el-tag type="info" v-if=" scope.row.status === 0">关闭</el-tag>
            <el-tag  type="success" v-else>开启</el-tag>
        </template>
      </el-table-column>
      <el-table-column align="center" label="总量">
        <template slot-scope="scope">
          <span>{{ scope.row.inventoryQuantity}}</span>
        </template>
      </el-table-column>
        <el-table-column align="center" label="剩余库存">
            <template slot-scope="scope">
                <span>{{ scope.row.remainingQuantity }}</span>
            </template>
        </el-table-column>
        <el-table-column align="center" label="每单价格">
            <template slot-scope="scope">
                <span>{{ scope.row.price}}</span>
            </template>
        </el-table-column>
      <el-table-column align="center" label="创建时间">
        <template slot-scope="scope">
          <span>{{ scope.row.createTime }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="更新时间">
        <template slot-scope="scope">
          <span>{{ scope.row.updateTime }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作" fixed="right" width="420">
        <template slot-scope="scope">
          <el-button
            size="small"
            type="primary"
            @click="editCard(scope.row.id)"
            style="margin-top: 10px;"
          >编辑</el-button>
          <el-button
              size="small"
              type="primary"
              @click="toRecord(scope.row.id)"
              style="margin-top: 10px;"
          >销售记录</el-button>
          <el-button
            size="small"
            type="danger"
            @click="delCard(scope.row.id)"

            style="margin-top: 10px;"
          >删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 页码 -->
    <template slot="footer">
      <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="listQuery.currentPage"
          :page-sizes="[10,20,30, 50]"
          :page-size="listQuery.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
      ></el-pagination>
    </template>
  </d2-container>
</template>
<script>
import {
  getVeriOrderList,
  removeVeriOrder
} from '@/api/demo/veriOrder'
export default {
  name: 'veriOrder',
  data () {
    return {
      tableKey: 0,
      dialogStatus: '',
      textMap: {
        update: '编辑',
        create: '创建'
      },
      total: 0,
      keyWordManger_btn_add: false,
      keyWordManger_btn_edit: false,
      keyWordManger_btn_del: false,
      dialogFormVisible: false,
      list: [],
      form: {
        color: '', // 名称
        word: '' // 关键词
      },
      listQuery: {
        currentPage: 1,
        pageSize: 20
      },
      listLoading: false,
      rules: {
        word: [
          {
            required: true,
            message: '关键词',
            trigger: 'blur'
          },
          {
            min: 1,
            max: 20,
            message: '长度在 1 到 20 个字符',
            trigger: 'blur'
          }
        ],
        color: [
          {
            required: true,
            message: '请选择背景色',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  created () {
    this.getSearch()
  },
  watch: {
    $route (to, from) {
      console.log('to', to)
      if (to.path === '/demo/veriOrder' && from.path === '/demo/veriOrder/edit') {
        this.getSearch(this.listQuery.currentPage)
      }
    }
  },
  methods: {
    // 每页条数
    handleSizeChange (val) {
      this.listQuery.pageSize = val
      this.getSearch(val)
    },
    // 当前页
    handleCurrentChange (val) {
      this.listQuery.currentPage = val
      this.getSearch(val)
    },
    getSearch (val) {
      let that = this
      if (val) {
        this.listQuery.currentPage = val
      } else {
        this.listQuery.currentPage = 1
      }
      getVeriOrderList(this.listQuery).then(
        res => {
          that.listLoading = true
          that.list = res.records
          that.total = Number(res.total)
          that.listLoading = false
        },
        err => {
          console.log('res', err)
        }
      )
    },
    add () {
      this.$router.push({
        path: '/demo/veriOrder/edit'
      })
    },
    // 编辑
    editCard (id) {
      this.$router.push({
        path: '/demo/veriOrder/edit?id=' + id
      })
    }, // 编辑
    toRecord (id) {
      this.$router.push({
        path: '/demo/veriOrder/record?id=' + id
      })
    },
    cancel () {
      let that = this
      that.dialogFormVisible = false
    },
    // 删除
    delCard (id) {
      let that = this
      this.$confirm('此操作将删除该关键词, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          removeVeriOrder(id).then(res => {
            that.$message({
              message: '删除成功',
              type: 'success',
              center: true
            })
            that.getSearch()
          })
        })
        .catch(() => {
          that.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    }
  }
}
</script>
<style scoped>
.span {
  width: 50px;
  height: 50px;
  display: block;
  margin: 0px auto;
  border: 1px solid rgba(0, 0, 0, 0.3);
}
</style>
